import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { ItAppImageLinkCard } from '../../ui-parts/ItAppImageLinkCard';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

export const ITApplications = () => {

  const screenId = 'MyM305';
  const { controlSettings, messageList } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isLoading, setIsLoading] = useState(false);
  const [itAppList, setItAppList] = useState(null);
  const isPc = useMediaQuery(mediaQuery.pc);

  useEffect(() => {
    const callbackRequestItApplicationsContents = (result) => {
      setItAppList(result)
    }
    apiRequest.requestJson(`api/it-applications/itApps`, 'GET', callbackRequestItApplicationsContents)
  }, []);

  if (itAppList === null)
    return <MyMProgress />

  // 2024.9.16 MyMine Version2.0対応 Modify Start
  /**
  * お気に入りItAppチェック
  * @param {Event} e イベント引数
  * @param {any} itAppId お気に入りItAppID
  */
  const preCheckFavorite = (itAppId) => {
    var itApp = itAppList.find(x => x.ItAppId === itAppId);

    // お気に入り件数が4件以上の場合、エラー
    if (!itApp.IsFavorite && itAppList.filter(x => x.IsFavorite === true).length >= 4) {
      alert(messageList.MyM_MSG_E_0050);
      return false;
    }
    return true;
  }

  /**
  * お気に入りItAppコールバック処理
  * @param {number} itAppId お気に入りItAppID
  */
  const callbackFavorite = (itAppId) => {
    var itApp = itAppList.find(x => x.ItAppId === itAppId);
    itApp.IsFavorite = !itApp.IsFavorite;
  }

  return (
    <div>
      {isLoading && <MyMProgress />}
      {
        isPc ?
          <>
            <br />
            <MyMLabel sx={{ fontWeight: "bold", color: "red", paddingLeft: "7%" }}>{controlSettings.LabelList.lblNotification}</MyMLabel>
            <br />
            <Grid container columns={21} sx={{ margin: "0 0 0 7%", width: "1650px" }}>
              {itAppList.map((y, j) => {
                return (
                  // 2024.9.16 MyMine Version2.0対応 Modify Start
                  <Grid item key={j} xs={3} sx={{ marginRight: "10%", marginBottom: "2%" }}>
                    <Box sx={{ width: '345px', height: 300 }}>
                      <ItAppImageLinkCard
                        screenId={screenId}
                        setIsLoading={setIsLoading}
                        preCheckFavorite={preCheckFavorite}
                        callbackFavorite={callbackFavorite}
                        itApp={y}
                        imageContainerHeight='180px'
                      />
                    </Box>
                  </Grid>
                )
              })}
            </Grid>
          </>
          :
          <>
            <MyMLabel sx={{ fontWeight: "bold", color: "red", padding:'10px 0 10px 7%' }}>{controlSettings.LabelList.lblNotification}</MyMLabel>
            <Grid container columns={21} sx={{ margin: "0 0 0 7%", width: "100%" }}>
              {itAppList.map((y, j) => {
                return (
                  // 2024.9.16 MyMine Version2.0対応 Modify Start
                  <Grid item key={j} xs={12} sm={8} md={6}  sx={{ marginRight: "10%", marginBottom: "2%" }}>
                    <Box sx={{ width: '300px', height: 300 }}>
                      <ItAppImageLinkCard
                        screenId={screenId}
                        setIsLoading={setIsLoading}
                        preCheckFavorite={preCheckFavorite}
                        callbackFavorite={callbackFavorite}
                        itApp={y}
                        imageContainerHeight='180px'
                      />
                    </Box>
                  </Grid>
                )
              })}
            </Grid>
          </>
      }
      
    </div>
  );
  // 2024.9.16 MyMine Version2.0対応 Modify End
}

export default ITApplications;